import {Chips} from 'plugins/modules/filter/components/Chips';
import {IFilterFacetVariant} from 'plugins/modules/filter/types';
import React, {FC, useCallback} from 'react';
import style from './style.module.scss';

export interface IProps {
    onApply: (variant: IFilterFacetVariant) => void;
    onDiscard: (variant: IFilterFacetVariant) => void;
    variants: IFilterFacetVariant[];
    withCount?: boolean;
}

export const ChipsFilterList: FC<IProps> = ({onApply, onDiscard, variants, withCount = true}) => {
    const handleChange = useCallback(
        (variant: IFilterFacetVariant) => (isChecked: boolean) => {
            if (isChecked) {
                onApply(variant);

                return;
            }

            onDiscard(variant);
        },
        [onApply, onDiscard],
    );

    return (
        <div className={style.main}>
            {variants
                .filter((filterVariant) => 0 !== filterVariant.count)
                .map((filterVariant) => {
                    const {code, count, isApplied, title} = filterVariant;

                    return (
                        <Chips
                            count={withCount ? count : undefined}
                            isDefaultChecked={isApplied}
                            key={code}
                            onChange={handleChange(filterVariant)}
                            title={String(title)}
                        />
                    );
                })}
        </div>
    );
};
